module.exports = __webpack_public_path__ + "img/stoofvlees_boil.36f5d43d.jpg";